// Product list for search autocomplete
export const allProducts = [
  // Whole Spices
  { name: 'Cardamom (Green)', category: 'Whole Spices', hsn: '090831' },
  { name: 'Cardamom (Black)', category: 'Whole Spices', hsn: '090832' },
  { name: 'Cinnamon', category: 'Whole Spices', hsn: '090611' },
  { name: 'Cloves', category: 'Whole Spices', hsn: '090710' },
  { name: 'Black Pepper', category: 'Whole Spices', hsn: '090411' },
  { name: 'Star Anise', category: 'Whole Spices', hsn: '090922' },
  { name: 'Bay Leaves', category: 'Whole Spices', hsn: '091099' },
  { name: 'Nutmeg', category: 'Whole Spices', hsn: '090811' },
  { name: 'Mace', category: 'Whole Spices', hsn: '090821' },
  { name: 'Fennel Seeds', category: 'Whole Spices', hsn: '090961' },
  { name: 'Cumin Seeds', category: 'Whole Spices', hsn: '090931' },
  { name: 'Coriander Seeds', category: 'Whole Spices', hsn: '090921' },
  { name: 'Turmeric Root', category: 'Whole Spices', hsn: '091030' },
  
  // Ground Spices
  { name: 'Ginger Powder', category: 'Ground Spices', hsn: '091012' },
  { name: 'Garlic Powder', category: 'Ground Spices', hsn: '071290' },
  { name: 'Onion Powder', category: 'Ground Spices', hsn: '071220' },
  { name: 'Turmeric Powder', category: 'Ground Spices', hsn: '091030' },
  { name: 'Red Chili Powder', category: 'Ground Spices', hsn: '090422' },
  { name: 'Cumin Powder', category: 'Ground Spices', hsn: '090932' },
  { name: 'Coriander Powder', category: 'Ground Spices', hsn: '090922' },
  { name: 'Black Pepper Powder', category: 'Ground Spices', hsn: '090412' },
];
